import React, { ChangeEvent, useEffect, useState } from "react";
import {Button, Form, StandaloneFormPage} from "tabler-react";
import {useHistory} from "react-router-dom";
import {StoreData, useAuth} from "../../hooks/AuthContext";
import {storeStatusDescription} from "../../interfaces/Store";

import logo from "../../assets/img/logo.svg";
import "./loginMonitor.css";

import { ApiFidegg } from "../../services/apiFideggAdmin";
import { Alerta } from "../../utils/Alerta";

function LoginStore() {
  const history = useHistory();

  const { isAuth, signIn, signOut } = useAuth();

  const [stores, setStores] = useState<StoreData[]>([]);

  const [ backUpStores, setBackUpStores ] = useState<StoreData[]>([]);
  const [selected, setSelected] = useState<number>(-1);

  useEffect(() => {
    if (!isAuth) {
      history.push("/");
      signOut();
    }

    const fetchStores = async () => {
      try {
        const storesRes = await ApiFidegg.monitor.getStores();
        setStores(storesRes);
        setBackUpStores(storesRes);
        setSelected(storesRes?.[0]['id'] ?? 0);
      } catch (err) {
        Alerta('Ocorreu um erro ao buscar as lojas');
      }
    };

    fetchStores();
  }, [history, signOut, isAuth]);

  function handleSignOut() {
    try {
      signOut();
      history.push("/");
    } catch (err) {
      Alerta("Erro ao efetuar logout");
    }
  }

  function handleNameChange(event: ChangeEvent<HTMLInputElement>) {
    let storesFilter = backUpStores
      ?.filter((e) => !!e.name)
      .filter((e) =>
        e.name!.toLocaleLowerCase().includes(event.target.value.toLocaleLowerCase())
      )
      .sort((a, b) => a.name!.localeCompare(b.name!));

    setStores(storesFilter);
    setSelected(
      storesFilter.length > 0 && typeof storesFilter[0].id === "number"
        ? storesFilter[0].id
        : -1
    );
  }

  function handleChangeSelected(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target;
    setSelected(parseInt(value));
  }

  async function handleSignInStore () {
    await signIn({
     id: selected,
     isMonitor: true,
    });

    history.push("dashboard");
  }

  return<>
    <Button.List className="button-out">
      <Button
        href="#"
        outline
        size="sm"
        RootComponent="a"
        color="primary"
        pill
        onClick={handleSignOut}
      >
        Sair
      </Button>
    </Button.List>

      <StandaloneFormPage
        imageURL={logo}
        children={
          <Form.Group label="Lista de lojas" className="form-store">
            <Form.Input
              placeholder="Buscar por nome da loja ..."
              onChange={handleNameChange}
            />
            <Form.Select
              height={"31px"}
              onChange={handleChangeSelected}
            >
              {stores!.map((store) => (
                <option key={store.id} value={store.id}>
                  {store.id +
                    " - " +
                    store.name +
                    " - " +
                    storeStatusDescription(store.status!)}
                </option>
              ))}
            </Form.Select>
            <Button
              size="sm"
              href="#"
              RootComponent="a"
              color="primary"
              onClick={handleSignInStore}
              className="button-store">
              Login
            </Button>
          </Form.Group>
        }
      />;
    </>
}

export default LoginStore;
